/*
 * ── INVASIVE THOT CUSTOM ─────────────────────────────────────
 * "NEW THOTS" in the menu drawer used to link to "/" — a dead
 * click when you're already home. Now it scrolls down to the
 * product grid; from any other page it goes home first, then
 * scrolls (via the #new-thots hash).
 *
 * Matches the menu item by its text, so renaming it in
 * admin → Navigation turns this back into a plain link.
 * ─────────────────────────────────────────────────────────────
 */
(function () {
  /* land on the subscribe box so SUBSCRIBE FOR EARLY ACCESS stays
     visible above the grid; fall back to the grid itself on pages
     without it */
  var TARGETS = ['.it-hero__subscribe', '[id*="__product_list"]'];

  function scrollToProducts() {
    var el = null;
    for (var i = 0; i < TARGETS.length && !el; i++) {
      el = document.querySelector(TARGETS[i]);
    }
    if (!el) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var link = e.target.closest('a.menu-drawer__menu-item');
    if (!link) return;
    if (link.textContent.trim().toLowerCase() !== 'new thots') return;
    e.preventDefault();
    var drawer = link.closest('details');
    if (drawer) drawer.removeAttribute('open');
    if (location.pathname === '/') {
      scrollToProducts();
    } else {
      location.href = '/#new-thots';
    }
  });

  if (location.hash === '#new-thots') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scrollToProducts);
    } else {
      scrollToProducts();
    }
  }
})();
